import React from "react";
import Modal, { ModalButton } from "common/modal";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

interface UnskipTopicModalProps {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ModalInfo = styled.div`
  text-align: left;
  font-size: 12px;
  color: #1070b6;
  font-weight: bold;
`;

const ModalText = styled.div`
  margin: 8px 0px 12px;
  font-size: 18px;
  color: #282828;
`;

const UnskipTopicModal = ({
  visible,
  onConfirm,
  onCancel,
}: UnskipTopicModalProps) => {
  const { t } = useTranslation("my_level");

  return (
    <Modal
      title={t("UN-SKIP TOPIC").toUpperCase()}
      visible={visible}
      onCancel={onCancel}
    >
      <ModalText>
        {t(
          'Are you sure you want to "un-skip" this topic? It will appear in your class searches and recommended classes again.'
        )}
      </ModalText>
      <ModalInfo>{t("Note: You can undo this at any time")}.</ModalInfo>

      <br />

      <ModalButton onClick={() => onConfirm()}>{t("UN-SKIP")}</ModalButton>
      <ModalButton onClick={() => onCancel()}>{t("CANCEL")}</ModalButton>
    </Modal>
  );
};

export default UnskipTopicModal;
